import { STORAGE_KEYS } from "./constants";

/**
 * Utilitários básicos de autenticação para evitar dependências circulares
 */
/**
 * "Manter-me conectado".
 *
 * Marcado: a sessão continua como sempre (tokens no localStorage).
 * Desmarcado: guardamos a preferência no localStorage e um cookie de SESSÃO (sem validade),
 * que o navegador apaga ao ser fechado. Na próxima abertura, se a preferência existe mas o
 * cookie sumiu, os tokens são descartados e o usuário volta ao login. O cookie (e não o
 * sessionStorage) é usado para que abrir outra aba não derrube a sessão.
 */
const SESSION_ONLY_KEY = "auth_session_only";
const SESSION_COOKIE = "virtus_smm_session";

const hasSessionCookie = () =>
  document.cookie.split("; ").some((c) => c === `${SESSION_COOKIE}=1`);

const writeSessionCookie = (active: boolean) => {
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = active
    ? `${SESSION_COOKIE}=1; path=/; SameSite=Lax${secure}`
    : `${SESSION_COOKIE}=; path=/; max-age=0; SameSite=Lax${secure}`;
};

export const setSessionPreference = (remember: boolean) => {
  try {
    if (remember) {
      localStorage.removeItem(SESSION_ONLY_KEY);
      writeSessionCookie(false);
    } else {
      localStorage.setItem(SESSION_ONLY_KEY, "1");
      writeSessionCookie(true);
    }
  } catch {
    /* storage/cookies indisponíveis: mantém o comportamento padrão */
  }
};

/** Chamar antes de ler os tokens: encerra sessões "só neste navegador" de uma abertura anterior. */
export const enforceSessionPolicy = () => {
  try {
    if (localStorage.getItem(SESSION_ONLY_KEY) === "1" && !hasSessionCookie()) {
      localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
      localStorage.removeItem(STORAGE_KEYS.TOKEN);
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user");
      localStorage.removeItem(SESSION_ONLY_KEY);
    }
  } catch {
    /* ignora */
  }
};

export const clearAuthStorage = () => {
  try {
    localStorage.removeItem(SESSION_ONLY_KEY);
    writeSessionCookie(false);
  } catch {
    /* ignora */
  }
  localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
  localStorage.removeItem(STORAGE_KEYS.TOKEN);
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("user");
  // sessionStorage.clear(); // Opcional
};

export const redirectToLogin = (message?: string) => {
  if (message) {
    sessionStorage.setItem("auth_redirect_message", message);
  }
  window.location.href = "/auth";
};
